export default "__VITE_ASSET__DKzDJx$2__"